export default class WindowHeight {
    oldWinHeight = 0;
    resizeTimer = null;

    constructor(props) {
        this.els = [].slice.call(document.querySelectorAll('[window-height]'));
        this.handleResize = this.handleResize.bind(this);
        this.setSize = this.setSize.bind(this);
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
    }

    handleResize() {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(this.setSize, 250);
    }

    setSize() {
        const winHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        if (winHeight !== 0 && Math.abs(this.oldWinHeight - winHeight) > 100) {
            this.els.forEach((el) => {
                el.style.height = winHeight + 'px';
            });
            this.oldWinHeight = winHeight;
        }
    }
}


// WEBPACK FOOTER //
// ./mysite/resources/js/components/window-height.js